import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "enable-background": "new 0 0 45 45",
  height: "45",
  viewBox: "0 0 45 45",
  width: "45",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m22.43 34.51c-.01 0-.02 0-.02 0l-17.43-.43c-.41-.01-.76-.26-.91-.64-.14-.38-.05-.81.25-1.09l12.55-11.8.04-.04.9-.75c.11-.09.24-.16.38-.2l18.94-5.12c.42-.11.87.06 1.1.42.24.37.21.84-.07 1.18l-14.96 18.11c-.19.23-.47.36-.77.36zm-14.97-2.37 14.51.36 12.65-15.31-15.7 4.24-.71.59z" }, null, -1),
    _createElementVNode("path", {
      d: "m18.41 15.7h2v18.33h-2z",
      transform: "matrix(.944 -.33 .33 .944 -7.1173 7.7961)"
    }, null, -1),
    _createElementVNode("path", {
      d: "m37.59 11.2h2v7.15h-2z",
      transform: "matrix(.9188 -.3948 .3948 .9188 -2.6969 16.4358)"
    }, null, -1)
  ])))
}
export default { render: render }